import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { PROGRESS_STEP_VALUE } from '@/constant';
import { useInterval } from '@/hooks/useSetInerval';

interface Props {
  reset: boolean;
}
const progressBar = [
  {
    index: 0,
    passed: true,
    active: true,
  },
  {
    index: 1,
    passed: false,
    active: false,
  },
  {
    index: 2,
    passed: false,
    active: false,
  },
  {
    index: 3,
    passed: false,
    active: false,
  },
];

const ProgressBar = ({ reset }: Props) => {
  const [nextProgress, setNextProgress] = React.useState(0);
  const [progress, setProgress] = React.useState(0);

  useInterval(() => {
    setProgress((prevProgress) => (prevProgress + PROGRESS_STEP_VALUE) % 101);

    if (progress >= 100) {
      setProgress(0);
      if (nextProgress < progressBar.length - 1) {
        setNextProgress(nextProgress + 1);
      } else {
        setProgress(0);
        setNextProgress(0);
      }
    }
  }, 1000);

  const updatedProgressBar = progressBar.map((pro: any) => ({
    ...pro,
    active: pro.index === nextProgress,
    passed: pro.index < nextProgress,
  }));

  React.useEffect(() => {
    if (reset) {
      setProgress(0);
      setNextProgress(0);
    }
  }, [reset]);

  return (
    <>
      {updatedProgressBar.map((pro: any) => {
        const value = pro.active ? progress : pro.passed ? 100 : 0;

        return (
          <LinearProgress
            key={pro.index}
            sx={{
              width: '100%',
              maxWidth: '200px',
              borderRadius: '34px',
              height: '8px',
            }}
            variant="determinate"
            value={value}
          />
        );
      })}
    </>
  );
};

export default ProgressBar;
